"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const uuid_1 = require("uuid");
const MultipleInputs = ({ inputs, setInputs }) => {
    const onChange = (id, e) => {
        const updatedInputs = inputs.map((input) => {
            const inputName = e.target.name;
            if (id === input.id) {
                const val = e.target.value;
                if (inputName === "label")
                    input[inputName] = e.target.value;
                if (inputName === "value") {
                    if (e.target.validity.valid) {
                        input[inputName] = e.target.value;
                    }
                    else if (val === "" || val === "-") {
                        input[inputName] = val;
                    }
                }
            }
            return input;
        });
        setInputs(updatedInputs);
    };
    const addInput = () => {
        if (inputs.length <= 5) {
            setInputs([...inputs, { id: (0, uuid_1.v4)(), label: "", value: "" }]);
        }
    };
    const removeInput = (id) => {
        const inputList = [...inputs];
        inputList.splice(inputList.findIndex((input) => input.id === id), 1);
        setInputs(inputList);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, inputs.map((input) => {
        return (react_1.default.createElement("div", { className: "flex w-full flex-col pb-8 pr-6 lg:flex-row", key: input.id },
            react_1.default.createElement("div", { className: "relative w-full mb-2 lg:mb-0 lg:mr-2 lg:w-1/2" },
                react_1.default.createElement("label", { className: "absolute z-50 text-xs -top-2 left-2 bg-white px-1", htmlFor: "label" }, "Label d'attribute"),
                react_1.default.createElement("input", { className: "form-input", type: "text", name: "label", value: input.label, onChange: (e) => onChange(input.id, e) })),
            react_1.default.createElement("div", { className: "relative w-full mb-2 lg:mb-0 lg:mr-2 lg:w-1/2" },
                react_1.default.createElement("label", { className: "absolute z-50 text-xs -top-2 left-2 bg-white px-1", htmlFor: "value" }, "Valeur d'attribute"),
                react_1.default.createElement("input", { className: "form-input invalid:border-red-300", type: "text", name: "value", value: input.value, pattern: "^-?[0-9]\\d*(\\.|,)?\\d*$", onChange: (e) => onChange(input.id, e) })),
            react_1.default.createElement("div", { className: "flex" },
                react_1.default.createElement("button", { className: "w-1/2 disabled:bg-gray-100 bg-green-200 hover:bg-green-300 text-gray-800 font-bold py-2 px-4 rounded-l flex justify-center items-center", disabled: inputs.length >= 5, onClick: (e) => {
                        e.preventDefault();
                        addInput();
                    } },
                    react_1.default.createElement("svg", { className: "fill-current w-4 h-4", width: "16", height: "16", fill: "currentColor", viewBox: "0 0 16 16" },
                        react_1.default.createElement("path", { d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" }))),
                react_1.default.createElement("button", { className: "w-1/2 disabled:bg-gray-100 bg-red-200 hover:bg-red-300 text-gray-800 font-bold py-2 px-4 rounded-r flex justify-center items-center", disabled: inputs.length === 1, onClick: () => removeInput(input.id) },
                    react_1.default.createElement("svg", { className: "fill-current w-4 h-4", width: "16", height: "16", fill: "currentColor", viewBox: "0 0 16 16" },
                        react_1.default.createElement("path", { d: "M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" }),
                        " ")))));
    })));
};
exports.default = MultipleInputs;
